import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildPageTitle } from '../utils/pageTitle';

/**
 * Keep the browser tab title in step with the current route.
 *
 * Call it from a LAYOUT — one per shell, above the routes it wraps — so the title
 * follows navigation within that shell. The employee app calls it from
 * CollapsibleDashboard, passing the sidebar leaf's name; the guard-only /yard tree
 * calls it from GuardLayout with nothing, letting buildPageTitle resolve the name
 * from the pathname.
 *
 * @param pageName Name resolved from the sidebar navigation, when the caller has
 *   one. Omit (or pass null) to resolve from the pathname alone — the registry /
 *   static / pattern fallbacks in pageTitle.ts.
 */
export function usePageTitle(pageName?: string | null): void {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = buildPageTitle(pageName ?? null, pathname);
  }, [pageName, pathname]);
}

export default usePageTitle;
